<div class="form-group">
  <div class="form-inline">
    <label class="control-label" style="width: 100%; justify-content: left">{{
      "LAYERMANAGER.layerEditor.interpolatedAttribute" | translateHs }}:</label>

    <select class="form-control form-select" style="width: 100%" [(ngModel)]="weightAttribute"
      [ngModelOptions]="{standalone: true}" (change)="changeAttrib()">
      <option [ngValue]="attr" *ngFor="let attr of attributes">
        {{attr}}
      </option>
    </select>
  </div>

  <hs-colormap-picker [(ngModel)]="colorMap"></hs-colormap-picker>

  <div class="row g-3">
    <div class="col-md-6">
      <label class="form-label">{{
        "LAYERMANAGER.layerEditor.min" | translateHs }}:</label>
      <input class="form-control inline" [(ngModel)]="min" name="hsIdwMin" />

    </div>
    <div class="col-md-6">
      <label class="form-label">{{
        "LAYERMANAGER.layerEditor.max" | translateHs }}:</label>
      <input class="form-control" [(ngModel)]="max" name="hsIdwMax" />
    </div>
  </div>

  <div class="row g-3 p-2">
    <div class="col-md-6">
      <button (click)="save()" class="btn btn-primary">{{"COMMON.apply" | translateHs }}</button>
    </div>
    <div class="col-md-6">
      <button (click)="cancel()" class="btn btn-outline-secondary">{{"COMMON.close" | translateHs }}</button>
    </div>
  </div>
</div>